import React from 'react';
import TextComponent from 'shared/components/TextComponent';
import { arrayUp } from 'shared/data/tooltips';

const ArrayUp = (props) => {
  const name = 'array_up';
  const {
    parameters,
    errorMessage,
    label,
    inputId,
    required,
    onChangeParameter,
    groupName,
    tooltip,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      inputClassName="array-up"
      name={name}
      value={parameters[name] || ''}
      onChange={onChange}
      tooltip={tooltip}
      groupName={groupName}
      errorMessage={errorMessage}
      inputId={inputId}
      required={required} />
  );
};

ArrayUp.defaultProps = {
  label: '# of up in array',
  tooltip: arrayUp,
};

export default ArrayUp;
